module.exports = __webpack_public_path__ + "2029d4b21e02cd38f5f90864387f4eff.svg";